import { actionCreator } from 'utils';
import * as PromotionTypes from '../types/promotionTypes';

// A D D   N E W   P R O M O T I O N
export function addNewPromotion(data, resellersProductGroup, isCustomized) {
    return {
        type: PromotionTypes.ADD_NEW_PROMOTION,
        data,
        resellersProductGroup,
        isCustomized,
    };
}

export function addNewPromotionRes(success) {
    return {
        type: actionCreator(PromotionTypes.ADD_NEW_PROMOTION, 'res'),
        success,
    };
}

export function addNewPromotionErr(error) {
    return {
        type: actionCreator(PromotionTypes.ADD_NEW_PROMOTION, 'err'),
        error,
    };
}
// A D D   N E W   P R O M O T I O N

// U P D A T E   T R A N S L A T E   P R O M O T I O N
export function updateTranslatePromotion(key) {
    return {
        type: PromotionTypes.UPDATE_TRANSLATE_PROMOTION,
        key,
    };
}

export function updateTranslatePromotionRes(key, loading, success) {
    return {
        type: actionCreator(PromotionTypes.UPDATE_TRANSLATE_PROMOTION, 'res'),
        key,
        loading,
        success,
    };
}

export function updateTranslatePromotionErr(key) {
    return {
        type: actionCreator(PromotionTypes.UPDATE_TRANSLATE_PROMOTION, 'err'),
        key,
    };
}
// U P D A T E   T R A N S L A T E   P R O M O T I O N

// L O A D   P R O M O T I O N S
export function loadPromotions() {
    return {
        type: PromotionTypes.LOAD_PROMOTIONS,
    };
}

export function loadPromotionsRes(data) {
    return {
        type: actionCreator(PromotionTypes.LOAD_PROMOTIONS, 'res'),
        data,
    };
}

export function loadPromotionsErr() {
    return {
        type: actionCreator(PromotionTypes.LOAD_PROMOTIONS, 'err'),
    };
}
// L O A D   P R O M O T I O N S

// S E T   P R O M O T I O N   F I L T E R   &   P A G I N A T I O N   &   S O R T   &   R E S E T
export function setPromotionFilters(key, value) {
    return {
        type: PromotionTypes.SET_PROMOTION_FILTER,
        key,
        value,
    };
}

export function setPromotionFiltersRes(data) {
    return {
        type: actionCreator(PromotionTypes.SET_PROMOTION_FILTER, 'res'),
        data,
    };
}

export function setPromotionPagination(key, pagination) {
    return {
        type: PromotionTypes.SET_PROMOTION_PAGINATION,
        key,
        pagination,
    };
}

export function setPromotionSort(sort) {
    return {
        type: PromotionTypes.SET_PROMOTION_SORT,
        sort,
    };
}

export function resetPromotionFilters() {
    return {
        type: PromotionTypes.RESET_PROMOTION_FILTERS,
    };
}
// S E T   P R O M O T I O N   F I L T E R   &   P A G I N A T I O N   &   S O R T   &   R E S E T

// L O A D   E D I T A B L E   P R O M O T I O N
export function loadEditablePromotion(id) {
    return {
        type: PromotionTypes.LOAD_EDITABLE_PROMOTION,
        id,
    };
}

export function loadEditablePromotionRes(data) {
    return {
        type: actionCreator(PromotionTypes.LOAD_EDITABLE_PROMOTION, 'res'),
        data,
    };
}

export function loadEditablePromotionErr(error) {
    return {
        type: actionCreator(PromotionTypes.LOAD_EDITABLE_PROMOTION, 'err'),
        error,
    };
}

export function setEmptyEditablePromotion() {
    return {
        type: PromotionTypes.SET_EMPTY_EDITABLE_PROMOTION,
    };
}
// L O A D   E D I T A B L E   P R O M O T I O N

// A T T A C H   R E S E L L E R S   P R O D U C T   G R O U P   T O   P R O M O T I O N
export function attachResellersProductGroupToPromotion(key) {
    return {
        type: PromotionTypes.ATTACH_RESELLERS_PRODUCT_GROUP_TO_PROMOTION,
        key,
    };
}

export function attachResellersProductGroupToPromotionRes(key, loading, success) {
    return {
        type: actionCreator(PromotionTypes.ATTACH_RESELLERS_PRODUCT_GROUP_TO_PROMOTION, 'res'),
        key,
        loading,
        success,
    };
}

export function attachResellersProductGroupToPromotionErr(key) {
    return {
        type: actionCreator(PromotionTypes.ATTACH_RESELLERS_PRODUCT_GROUP_TO_PROMOTION, 'err'),
        key,
    };
}
// A T T A C H   R E S E L L E R S   P R O D U C T   G R O U P   T O   P R O M O T I O N

// L O A D   S E L L   P R I C E S   F O R   P R O M O T I O N
export function loadSellPricesForPromotion(data) {
    return {
        type: PromotionTypes.LOAD_SELL_PRICES_FOR_PROMOTION,
        data,
    };
}

export function loadSellPricesForPromotionRes(data) {
    return {
        type: actionCreator(PromotionTypes.LOAD_SELL_PRICES_FOR_PROMOTION, 'res'),
        data,
    };
}

export function loadSellPricesForPromotionErr() {
    return {
        type: actionCreator(PromotionTypes.LOAD_SELL_PRICES_FOR_PROMOTION, 'err'),
    };
}

export function setSellPricesPagination(key, pagination) {
    return {
        type: PromotionTypes.SET_SELL_PRICES_PAGINATION,
        key,
        pagination,
    };
}

export function setEmptySellPrices() {
    return {
        type: PromotionTypes.SET_EMPTY_SELL_PRICES,
    };
}
// L O A D   S E L L   P R I C E S   F O R   P R O M O T I O N

// E D I T   P R O M O T I O N
export function editPromotion(data, resellersProductGroup, isCustomized) {
    return {
        type: PromotionTypes.EDIT_PROMOTION,
        data,
        resellersProductGroup,
        isCustomized,
    };
}

export function editPromotionRes(success) {
    return {
        type: actionCreator(PromotionTypes.EDIT_PROMOTION, 'res'),
        success,
    };
}

export function editPromotionErr(error) {
    return {
        type: actionCreator(PromotionTypes.EDIT_PROMOTION, 'err'),
        error,
    };
}
// E D I T   P R O M O T I O N

// S E T   S E L L   P R I C E S   F I L T E R   &   S O R T   &   R E S E T
export function setPromotionSellPricesFilters(key, value) {
    return {
        type: PromotionTypes.SET_PROMOTION_SELL_PRICES_FILTER,
        key,
        value,
    };
}

export function setPromotionSellPricesFiltersRes(data) {
    return {
        type: actionCreator(PromotionTypes.SET_PROMOTION_SELL_PRICES_FILTER, 'res'),
        data,
    };
}

export function setPromotionSellPricesSort(sort) {
    return {
        type: PromotionTypes.SET_PROMOTION_SELL_PRICES_SORT,
        sort,
    };
}

export function resetPromotionSellPricesFilters() {
    return {
        type: PromotionTypes.RESET_PROMOTION_SELL_PRICES_FILTERS,
    };
}
// S E T   S E L L   P R I C E S   F I L T E R   &   S O R T   &   R E S E T


// S A V E   P R O M O   T O   C U S T O M I Z E
export function savePromoToCustomizeRes(data) {
    return {
        type: actionCreator(PromotionTypes.SAVE_PROMO_TO_CUSTOMIZE, 'res'),
        data,
    };
}

export function setEmptyPromoToCustomize() {
    return {
        type: PromotionTypes.SET_EMPTY_PROMO_TO_CUSTOMIZE,
    };
}
// S A V E   P R O M O   T O   C U S T O M I Z E


// A T T A C H   S E L L P R I C E S   T O   P R O M O T I O N
export function attachSellpricesToPromotion(data) {
    return {
        type: PromotionTypes.ATTACH_SELLPRICES_TO_PROMOTION,
        data,
    };
}

export function attachSellpricesToPromotionRes(success) {
    return {
        type: actionCreator(PromotionTypes.ATTACH_SELLPRICES_TO_PROMOTION, 'res'),
        success,
    };
}

export function attachSellpricesToPromotionErr(error) {
    return {
        type: actionCreator(PromotionTypes.ATTACH_SELLPRICES_TO_PROMOTION, 'err'),
        error,
    };
}
// A T T A C H   S E L L P R I C E S   T O   P R O M O T I O N

// L O A D   C H O O S E N   S E L L P R I C E S
export function loadPromotionSellPrices(promotionId) {
    return {
        type: PromotionTypes.LOAD_PROMOTION_SELLPRICES,
        promotion_id: promotionId,
    };
}

export function loadPromotionSellPricesRes(data) {
    return {
        type: actionCreator(PromotionTypes.LOAD_PROMOTION_SELLPRICES, 'res'),
        data,
    };
}

export function loadPromotionSellPricesErr() {
    return {
        type: actionCreator(PromotionTypes.LOAD_PROMOTION_SELLPRICES, 'err'),
    };
}
// L O A D   C H O O S E N   S E L L P R I C E S

// U P D A T E   S E L L   P R I C E S
export function updateSellPrices(data) {
    return {
        type: PromotionTypes.UPDATE_SELL_PRICES,
        data,
    };
}

export function updateSellPricesRes(payload) {
    return {
        type: actionCreator(PromotionTypes.UPDATE_SELL_PRICES, 'res'),
        payload,
    };
}

export function updateSellPricesErr() {
    return {
        type: actionCreator(PromotionTypes.UPDATE_SELL_PRICES, 'err'),
    };
}
// U P D A T E   S E L L   P R I C E S

// D E L E T E   S E L L   P R I C E S
export function deleteSellPrices(data) {
    return {
        type: PromotionTypes.DELETE_SELL_PRICES,
        data,
    };
}

export function deleteSellPricesRes(payload) {
    return {
        type: actionCreator(PromotionTypes.DELETE_SELL_PRICES, 'res'),
        payload,
    };
}

export function deleteSellPricesErr() {
    return {
        type: actionCreator(PromotionTypes.DELETE_SELL_PRICES, 'err'),
    };
}
// D E L E T E   S E L L   P R I C E S

// S E T   P R O D U C T   G R O U P   F I L T E R   &   P A G I N A T I O N   &   S O R T   &   R E S E T   F O R   S E L L P R I C E S
export function setPromoSellPricesFilters(key, value) {
    return {
        type: PromotionTypes.SET_PROMO_SELL_PRICES_FILTER,
        key,
        value,
    };
}

export function setPromoSellPricesFiltersRes(data) {
    return {
        type: actionCreator(PromotionTypes.SET_PROMO_SELL_PRICES_FILTER, 'res'),
        data,
    };
}

export function setPromoSellPricesPagination(key, pagination) {
    return {
        type: PromotionTypes.SET_PROMO_SELL_PRICES_PAGINATION,
        key,
        pagination,
    };
}

export function resetPromoSellPricesFilters() {
    return {
        type: PromotionTypes.RESET_PROMO_SELL_PRICES_FILTERS,
    };
}
// S E T   P R O D U C T   G R O U P   F I L T E R   &   P A G I N A T I O N   &   S O R T   &   R E S E T   F O R   S E L L P R I C E S

// S E T   D I S A B L E   B I L L I N G   P R O M O T I O N
export function setDisablePromotion(value, key) {
    return {
        type: PromotionTypes.SET_DISABLE_PROMOTION,
        value,
        key,
    };
}

export function setDisablePromotionRes(data) {
    return {
        type: actionCreator(PromotionTypes.SET_DISABLE_PROMOTION, 'res'),
        data,
    };
}
// S E T   D I S A B L E   B I L L I N G   P R O M O T I O N
